import { Category } from "@/components/catelog/category-card";

export type MasterDataState = {
  categories: Category[];
  setCategories: (categories: Category[]) => void;
  getCategories: () => Category[];
  clearCategories: () => void;

  deals: Category[];
  setDeals: (deals: Category[]) => void;
  getDeals: () => Category[];
  clearDeals: () => void;
};

export const createMasterDataSlice = (
  set: (state: Partial<MasterDataState>) => void,
  get: () => MasterDataState
) => ({
  categories: [],
  setCategories: (categories: Category[]) => set({ categories }),
  getCategories: () => get().categories,
  clearCategories: () => set({ categories: [] }),

  deals: [],
  setDeals: (deals: Category[]) => set({ deals }),
  getDeals: () => get().deals,
  clearDeals: () => set({ deals: [] }),
})